import {httpClient} from "@/Repositories/Indicators/HttpClient";
import _ from "lodash";

export default {

    /**
     * Search data sources matching given criteria
     *
     * @param searchArguments
     * @returns {Promise<*>}
     */
    async searchDataSources(searchArguments) {
        return httpClient.get(route('indicators.data-sources.search', searchArguments));
    }
}
